<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: medication-family.component.html
 * Generated by: Toji Mathew
 * Date .......: 3/21/2023
--------------------------------------->
<div class="medication-family-form-container">
    <div class="query-strip-container mat-elevation-z2">
    <table height="100%">
        <TR>
            <TD class="table-title-cell">
                <i class="fa fa-medkit fa-fw table-icon-header"
                   style="width: 2em"></i>{{formTitle}}
            </TD>
            
            <TD align="center" style="min-width: 400px;">
                <input text id="txtFilter" #txtFilter
                       class="qs_filter-field" [disabled]="this.isEditing"
                       (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                <button mat-button matSuffix mat-icon-button
                        matTooltip="Clear the filter" aria-label="Clear"
                        (click)="txtFilter.value=''; clearFilter();">
                    <mat-icon>close</mat-icon>
                </button>

                <button mat-button class="command-button" [disabled]="busyCursor"
                        matTooltipPosition="below"
                        style="margin-top: 5px; width:100px;"
                        matTooltip="Query the system for service request records"
                        (click)="openSearchDialog()"
                        mat-button>
                    <mat-icon>search</mat-icon>
                    Search
                </button>
             </TD>
            <TD class="qs-label-cell"
                style="font-size: 10pt; width: 15%; text-align: right;">Status:&nbsp;&nbsp;
                <dw-dropdown [disabled]="busyCursor"
                             [selectedItem]="selectedStatusFilter"
                             [useStatusOptions]="'statusdeletedall'"
                             (itemSelected)="onChangeStatusFilterValue($event)"
                             [controlWidth]="'100px'"
                             matTooltip="Filter the list by a status">
                </dw-dropdown>
            </TD>
            <TD class="qs-label-cell" style="width: 60px; text-align: center;"><!-- Status: --></TD>
            <TD class="table-pagination-cell" align="right">{{pagination}} Record(s) ...</TD>
        </TR>
    </table>
</div>

<mat-drawer-container autosize >
    <!-------------------------->
    <!-- Right hand drawer    -->
    <!-- Open state           -->
    <!-------------------------->
    <mat-drawer position="end" opened="true" class="mat-elevation-z2"
        style="border: .5px solid #e1e1e1" #drawer
        mode="side" disableClose="true">
        <div style="max-width: 550px; padding: 2px;"  >

            <table [hidden]="!propContainerState"
                   class="prop-notes-outer-container">
                <TR>
                    <TD align="left" style="width: 35px; padding: 0;">
                        <button id="medication-family-toggle-drawer-close-btn"  mat-icon-button
                            (click)="onPropertiesToggle()">
                            <mat-icon>arrow_right</mat-icon>
                        </button>
                    </TD>
                    <TD width="100%" style="text-align: left;">
                        <b>Additional Properties</b>
                    </TD>
                    <TD width="35px"></TD>
                </TR>
            </table>
            <div [hidden]="!propContainerState"
                 class="prop-menu-container" style="width:545px;">
                 <mat-tab-group class="prop-tab-group"
                     [(selectedIndex)]=selectedDrawerIndex (selectedTabChange)="doDrawerTabChange($event)"
                     style="height: calc(100% - 2px)">

                     <mat-tab label="Properties"> <app-medication-properties #properties

                             [View]="'MedicationFamily'"></app-medication-properties>
                     </mat-tab>
					 <mat-tab label="Ingredients" *ngIf="visibleNotesTab">
                         <app-medication-ingredients #ingredients style="border-top: .5px solid #e1e1e1; " 
                             [Medication]="selectedRecord" [View]="'MedicationFamily'"> 
                         </app-medication-ingredients>
                    </mat-tab>
                    <mat-tab label="Notes" *ngIf="visibleNotesTab"> 
                         <app-notes #notes style="border-top: .5px solid #e1e1e1; "  
                              [callingComponent]="'medication-family'"
                              [parentId]="selectedRecord?.id">
                         </app-notes>
                    </mat-tab>
                </mat-tab-group>
              </div>
           </div>
        <div>
        <!----------------------->
        <!-- Right hand Drawer -->
        <!-- retracted state ---->
        <!----------------------->
        <div [hidden]="propContainerState" width="100%">
            <button id="medication-family-toggle-drawer-open-btn" mat-icon-button (click)="onPropertiesToggle()" >
                <mat-icon>arrow_left</mat-icon>
            </button>
        </div>

        <div class="rotate-text" [hidden]="propContainerState">
            Additional Properties
        </div>
      </div>
    </mat-drawer>


        <!--------------------------->
        <!-- RECORDS TABLE         -->
        <!--------------------------->
        <div #tb1 [ngClass]="contentClassName" class="table-container mat-elevation-z1"
            (keydown)="tableKeyDown($event)" tabindex="-1">
            <table mat-table [dataSource]="dataSource" matSort
                (matSortChange)="onSortChange($event)">

                <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on
                  the row definition" -->

                <!-- Position Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style">Id</th>
                    <td mat-cell style="width:20px!important;"  class="mat-table-row-style"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.id}}</td>
                </ng-container>

                <ng-container matColumnDef="description" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="mat-table-header-style">Description</th>
                    <td mat-cell style="width:50% !important;" class="mat-table-row-style"
                        *matCellDef="let element">{{element.description}}</td>
                </ng-container>

                <ng-container matColumnDef="itemPrefix" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style" >Item Prefix</th>
                    <td mat-cell style="width:100px; !important;" class="mat-table-row-style"
                        *matCellDef="let element">{{element.itemPrefix}}</td>
                </ng-container>

                <ng-container matColumnDef="schedule">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style">Schedule</th>
                    <td mat-cell class="mat-table-row-style" style="width: 100px; text-align: center;"
                        *matCellDef="let element">{{element.schedule}}</td>
                </ng-container>

                <ng-container matColumnDef="invWarningThreshold" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style">Threshold Level</th>
                    <td mat-cell style="width:150px !important;text-align: left;" class="mat-table-row-style"
                        *matCellDef="let element">{{element.invWarningThreshold}}%</td>
                </ng-container>

                <ng-container matColumnDef="expirationGraceDays" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style">Grace Days</th>
                    <td mat-cell style="width:130px !important;" class="mat-table-row-style"
                        *matCellDef="let element">{{element.expirationGraceDays}} day(s)</td>
                </ng-container>
                <!-- Active Status -->
                <ng-container matColumnDef="activeStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style"
                        style="background-color: white; z-index:99999">Status
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-table-row-style" style="width:130px">

                        <dw-dropdown *ngIf="selectedRecord?.id == element.id"
                                     [disabled]="isEditing"
                                     [style]="{'font-size':'10pt'}"
                                     [useStatusOptions]="'status'"
                                     [selectedItem]="element.activeStatus"
                                     [controlWidth]="'100px'"
                                     (itemSelected)="element.activeStatus = $event; onStatusChange()">
                        </dw-dropdown>

                        <span *ngIf="selectedRecord?.id !== element.id"
                              style="width:130px">{{element.activeStatus}}</span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                    [ngClass]="{'row-selected': this.selectedRecord.id == row.id}"
                    (click)="onRowClicked(row)">
                </tr>
            </table>
            <app-dw-spinner [visible]="busyCursor"> </app-dw-spinner>
            <div [hidden]="hideNoRecs" class="no-recs-found">No Records Found</div>
        </div>
        <!-------------------------------------->
        <!-- Control Strip                    -->
        <!-------------------------------------->
        <div class="mat-elevation-z2 control-strip">
            <button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
                    matTooltipPosition="above"
                    class="command-button" matTooltip="Add a new record"
                    (click)="addModifyRecord(true)" mat-button>
                <mat-icon>add_circle_outline</mat-icon>
                Add New
            </button>
            <button *ngIf="visibleModify" mat-button class="command-button"
                    style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
                    matTooltipPosition="above"
                    matTooltip="Update a selected record" (click)="addModifyRecord(false)"
                    mat-button>
                <mat-icon>edit</mat-icon>
                Update
            </button>
        </div>
        <!------------------------------->
        <!--  Detail panel             -->
        <!------------------------------->
        <div id="medication-family-details-panel"
             class="medication-family-detail-container mat-elevation-z2"  >
          <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange($event)"
                            [(selectedIndex)]=selectedTabIndex>
                <mat-tab label="Details" [disabled]="isEditing">
                    <div class="sub-tab-container-class detail-tab-additional">
                        <div class="dwform" style="padding-right: 15px;padding-left: 5px;">

                            <div class="dwform-cell-nopadding" style="min-width: 510px;">
                                <div class="dwform-row-double-gap"></div>
                                <div class="dwform-row">
                                    <label class="label-field">ID:</label> <span
                                        class="form-required"> </span>
                                    <input class="input-field-short" style="width:80px" disabled="true"
                                           [(ngModel)]="id"
                                           type="text">
                                </div>
                                <div class="dwform-row-gap"></div>
                                <div class="dwform-row">
                                    <label class="label-field">Item Prefix:</label>
                                    <span class="form-required">*</span>
                                    <input id="item_prefix" class="input-field-shortest"
                                           (focusout)="checkUniqueItemPrefix()"
                                           style="width:80px;"
                                           [disabled]="!isEditing"
                                           matTooltip="Used to identify finished forms"
                                           [(ngModel)]="itemPrefix" maxlength="60"
                                           placeholder="<Item Pref.>"
                                           type="text" max="100" min="0">

                                    <button mat-button class="command-button"
                                            *ngIf="isEditing"
                                            (click)="doItemPrefixHint()"
                                            style="scale: 90%; width: 80px;margin-left: 35px;"
                                            matTooltip="get the next number"
                                            matTooltipPosition="right"
                                    >Hint</button>
                                </div>

								<div class="dwform-row-gap"></div>
                                <div class="dwform-row">
                                <label class="label-field" style="vertical-align:top;">Description:</label>
                                <span class="form-required">*</span>
                                <textarea id="description" class="text-area-input text-area-override"
                                       [disabled]="!isEditing"
                                       [(ngModel)]="description"
                                       placeholder="<Description>"
                                       type="text">
                                    </textarea>
                                </div>
                                <div class="dwform-row-gap"></div>
                                <div class="dwform-row">
                                    <label class="label-field">Threshold Level:</label>
                                    <span class="form-required">*</span>
                                    <input id="inv_warning_threshold" class="input-field-shortest"
                                           style="width:50px;"
                                           [disabled]="!isEditing"
                                           matTooltip="Show a warning when inventory reaches this level"
                                           [(ngModel)]="invWarningThreshold" maxlength="60"
                                           placeholder="<Number>"
                                           type="number" max="100" min="0"><span>%</span>
                                </div>
                                <div class="dwform-row-gap"></div>

                                <div class="dwform-row">
                                    <label class="label-field">Grace Days:</label>
                                    <span class="form-required">*</span>
                                    <input id="expiration_grace_days" class="input-field-shortest"
                                           style="width:50px;"
                                           matTooltip="Disallow medication when this number of days from the expiration date is reached"
                                           [disabled]="!isEditing"
                                           [(ngModel)]="expirationGraceDays" maxlength="60"
                                           placeholder="<Number>"
                                           type="number" max="100" min="0">
                                </div>
                                  <div class="dwform-row-gap"></div>
                               
                                <div class="dwform-row-gap"></div>
                            </div>
                             <div class="dwform-cell-nopadding" style="min-width: 500px;">
                                <div class="dwform-row-double-gap"></div>
                                 <div class="dwform-row">
                                    <label class="label-field">Schedule:</label>
                                    <span class="form-required">*</span>
                                    <input id="schedule" class="input-field-shortest"
                                           style="width:75px;"
                                           matTooltip="Indicates the drug's classification according to regulatory guidelines"
                                           [disabled]="!isEditing"
                                           [(ngModel)]="schedule" maxlength="60"
                                           placeholder="<0-5>"
                                           type="number" max="5" min="0">
                                </div>
                                <div class="dwform-row-gap"></div>
                                <div class="dwform-row">
                                    <label class="label-field">Status:</label>
                                    <span class="form-required">*</span>
                                  	<mat-select [disabled]="!isEditing" [(ngModel)]="valStatus"
											id="status" placeholder="- Please Select -"
											disableOptionCentering floatLabel="never"
											panelClass="local-drop-down-panel" class="dw-mat-select"
											style="width: 167px;font-size: 10pt;"
										[style.backgroundColor]="disabledFlag?'whitesmoke':'white'">
									<mat-option value="Active">Active</mat-option> <mat-option
										value="InActive">InActive</mat-option> </mat-select>
		                                </div>
                             </div>
                        </div>
                        <!----------------------->
                        <!-- ERROR LINE --------->
                        <!----------------------->
                        <div class="error-line" [hidden]='!strErr.length'
                            style="text-align:left; margin-left: 5px;bottom: 38px;">{{strErr}}</div>
                        <!----------------------->
                        <!-- SAVE STRIP        -->
                        <!----------------------->
                        <div class="save-close-strip" style="bottom: 3px;">

                            <button mat-button class="command-button" *ngIf="this.isEditing"
                                    (click)="submitRecord()" matTooltip="Submit the selected record"
                                    mat-button>
                                <mat-icon>check_circle_outline</mat-icon>
                                Submit
                            </button>
                            <button mat-button class="command-button" *ngIf="this.isEditing"
                                    (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
                                <mat-icon>highlight_off</mat-icon>
                                Cancel
                            </button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="History" [disabled]="isEditing">
                    <div class="sub-tab-container-class detail-tab-additional">
                       <transaction-history #history> </transaction-history>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </mat-drawer-container>
</div>
<p-dialog header="Medication Family Search" [focusOnShow]="false"
          [(visible)]="displaySearchDlg" [modal]="true"
          [style]="{width: '630px', height: '245px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-search-medications #search
                            (submitClicked)="globalSearchSelect($event)"
                            [callFrom]="'medicationfamily'"
                            (cancelClicked)="displaySearchDlg=false">
    </app-search-medications>
</p-dialog>
